<section class="hero-background pt-5" role="img" aria-label="We handle it all">
  <div>
    <div class="mb-md-5">
      <div class="justify-content-center d-flex align-items-center mt-lg-5">
        <div class="side-line white-line d-none d-md-inline"></div>
        <div class="mx-5">
          <h2 class="text-white my-4">We handle it all</h2>
        </div>
        <div class="side-line white-line d-none d-md-inline"></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <p class="lead subhead-2 text-white text-center">Put your gear on Rubbl. You get paid. We handle everything else.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-5 w-100 d-lg-none"></div>
    <div class="container-fluid container-xl mb-5">
      <div class="row pb-5">
        <div *ngFor="let marketingCard of marketingCards; index as i" class="col-xs-12 col-md-4 p-lg-5">
          <div class="mb-5">
            <h4 class="text-white mb-4 text-left">{{ marketingCard.title }}</h4>
            <h6 class="text-white mt-4 card-text">{{ marketingCard.body }}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
